import { Buffer } from 'buffer';

import { useSzafir } from '../../../common/hooks/useSzafir';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

export async function signP1XmlWithSzafir(
  szafir: ReturnType<typeof useSzafir>,
  spd: ReturnType<typeof useSpdCore>,
  pin: string,
  documentId: string,
): Promise<string> {
  const taskList = await spd.szafir.getTaskListForJudgmentP1(documentId);

  const szafirResult = await new Promise<Buffer | null>((resolve, reject) => {
    void szafir.signDocument(
      taskList,
      pin,
      documentId,
      '',
      false,
      result => resolve(result),
      error =>
        reject({
          response: new Error('Podpis Szafir nie powiódł się: ' + error),
        }),
    );
  });
  if (!szafirResult) {
    throw { response: new Error('Brak podpisanego dokumentu z Szafir') };
  }
  return szafirResult.toString('base64');
}
